module.exports = __webpack_public_path__ + "img/logo.3e3538b0.svg";